/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type GoogleConfigContainer_auth = {
    readonly integrations: {
        readonly google: {
            readonly callbackURL: string;
        };
    };
    readonly " $refType": "GoogleConfigContainer_auth";
};
export type GoogleConfigContainer_auth$data = GoogleConfigContainer_auth;
export type GoogleConfigContainer_auth$key = {
    readonly " $data"?: GoogleConfigContainer_auth$data;
    readonly " $fragmentRefs": FragmentRefs<"GoogleConfigContainer_auth">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "GoogleConfigContainer_auth",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "AuthIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "GoogleAuthIntegration",
                    "kind": "LinkedField",
                    "name": "google",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "callbackURL",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Auth",
    "abstractKey": null
} as any);
(node as any).hash = '62093243da4a030bc139f307c62a286e';
export default node;
